<template>
  <div>
    <b-card class="container-fluid mb-0">
      <div
        v-if="isGlobalSettingsLoading && isFirstTimeLoading"
        class="empty-box-height"
      >
        <!-- <div class="progress2 progress-moved">
          <div class="progress-bar2"></div>
        </div> -->
      </div>
      <div v-else class="row">
        <div class="col-12 col-md-4 col-lg-3 px-2 setting-link">
          <div class="status__container">
            <div class="text__status">CURRENT STATUS</div>
            <div class="d-flex flex-column w-100 mt-21-px">
              <div class="w-100 box__status mb-15-px">
                <div
                  v-if="currentStatus.webService.isLoading"
                  class="empty-card-height px-1"
                >
                  <div class="progress2 progress-moved">
                    <div class="progress-bar2"></div>
                  </div>
                </div>
                <div v-else class="box__status-padding">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <label class="text__box-title">Web Server</label>
                    <b-badge
                      pill
                      :variant="statusVariant(currentStatus.webService.status)"
                    >
                      {{ statusWording(currentStatus.webService.status) }}
                    </b-badge>
                  </div>
                  <span class="text__box-date">{{
                    currentStatus.webService.date
                  }}</span>
                </div>
              </div>

              <div class="w-100 box__status mb-15-px">
                <div
                  v-if="currentStatus.apiServices.isLoading"
                  class="empty-card-height px-1"
                >
                  <div class="progress2 progress-moved">
                    <div class="progress-bar2"></div>
                  </div>
                </div>
                <div v-else class="box__status-padding">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <label class="text__box-title">API Services</label>
                    <b-badge
                      pill
                      :variant="statusVariant(currentStatus.apiServices.status)"
                    >
                      {{ statusWording(currentStatus.apiServices.status) }}
                    </b-badge>
                  </div>
                  <span class="text__box-date">{{
                    currentStatus.apiServices.date
                  }}</span>
                </div>
              </div>

              <div class="w-100 box__status mb-15-px">
                <div
                  v-if="currentStatus.databaseBackup.isLoading"
                  class="empty-card-height px-1"
                >
                  <div class="progress2 progress-moved">
                    <div class="progress-bar2"></div>
                  </div>
                </div>
                <div v-else class="box__status-padding">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <label class="text__box-title">Database Backup</label>
                    <b-badge
                      pill
                      :variant="
                        statusVariant(currentStatus.databaseBackup.status)
                      "
                    >
                      {{ statusWording(currentStatus.databaseBackup.status) }}
                    </b-badge>
                  </div>
                  <span class="text__box-date">
                    {{ currentStatus.databaseBackup.date }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-8 col-lg-9 px-2">
          <div class="container-fluid setting-value p-0">
            <div class="d-flex flex-column setting__item">
              <div class="col-12 px-0 text__header">Global Settings</div>
              <div class="col-12 col-lg-5 px-0 mt-1">
                <div class="row">
                  <div class="col-8">
                    <atom-input
                      v-model="
                        currentConfigData.iamConfig.jwtTokenLifetimeHours
                      "
                      title="Customer Token Lifetime"
                      placeholder="Customer Token Lifetime"
                      :isAsterisk="true"
                      :isError="isErrorAtTokenLifetime"
                      :isDisable="!hasUpdatePermission"
                      errorMessage="Value must be positive integer"
                    ></atom-input>
                  </div>
                  <div class="col-4">
                    <div class="custom-margin-top-30">Hour</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex flex-column setting__item">
              <div class="col-12 px-0 text__header">
                Notification Configuration
              </div>
              <div class="col-12 col-lg-5 px-0 mt-1">
                <div class="row">
                  <div class="col-8">
                    <div class="d-flex align-items-center custom-small-font">
                      <span>
                        Refresh Interval
                        <span class="font-color-danger">*</span>
                      </span>
                      <div class="d-flex custom-margin-left">
                        <div id="ticket-noti-refresh">
                          <feather-icon
                            icon="InfoIcon"
                            size="12"
                            class="alert__icon"
                          />
                        </div>
                        <b-tooltip
                          target="ticket-noti-refresh"
                          placement="right"
                          boundary="window"
                          variant="primary"
                        >
                          <div class="description__container">
                            <span>ระยะเวลาการตรวจสอบการแจ้งเตือน</span>
                          </div>
                        </b-tooltip>
                      </div>
                    </div>
                    <atom-input
                      v-model="
                        currentConfigData.notificationConfig.refreshInterval
                      "
                      placeholder="30"
                      :isError="isErrorAtRefreshInterval"
                      :isDisable="!hasUpdatePermission"
                      errorMessage="Value must be positive integer"
                    ></atom-input>
                  </div>
                  <div class="col-4">
                    <div class="custom-margin-top-30">Second</div>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-8">
                    <div class="d-flex align-items-center custom-small-font">
                      <span>
                        Fetch Range
                        <span class="font-color-danger">*</span>
                      </span>
                      <div class="d-flex custom-margin-left">
                        <div id="ticket-noti-fetch">
                          <feather-icon
                            icon="InfoIcon"
                            size="12"
                            class="alert__icon"
                          />
                        </div>
                        <b-tooltip
                          target="ticket-noti-fetch"
                          placement="right"
                          boundary="window"
                          variant="primary"
                        >
                          <div class="description__container">
                            <span>ช่วงระยะเวลาของการแจ้งเตือนที่ทำการแสดง</span>
                          </div>
                        </b-tooltip>
                      </div>
                    </div>
                    <atom-input
                      v-model="
                        currentConfigData.notificationConfig.expirationInterval
                      "
                      placeholder="1"
                      :isAsterisk="true"
                      :isError="isErrorAtExpirationInterval"
                      :isDisable="!hasUpdatePermission"
                      errorMessage="Value must be positive integer"
                    ></atom-input>
                  </div>
                  <div class="col-4">
                    <div class="custom-margin-top-30">Day</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="setting__item">
              <div class="col-12 px-0 text__header">
                Global Email Configuration
              </div>
              <div class="d-md-flex">
                <div
                  class="col-12 col-md-5 px-0 d-flex align-items-center mt-1"
                >
                  <atom-input
                    v-model="currentConfigData.smtpServerConfig.host"
                    title="SMTP Host"
                    placeholder="smtp.domain.com"
                    :isAsterisk="true"
                    :isError="isErrorAtSmtpServerConfigHost"
                    :isDisable="!hasUpdatePermission"
                  ></atom-input>
                </div>
                <div
                  class="col-12 col-md-3 px-0 d-flex align-items-center pl-md-1 mt-1"
                >
                  <atom-input
                    v-model="currentConfigData.smtpServerConfig.port"
                    title="Port"
                    placeholder="Port"
                    :isAsterisk="true"
                    :isError="isErrorAtSmtpServerConfigPort"
                    :isDisable="!hasUpdatePermission"
                  ></atom-input>
                </div>
              </div>
              <div class="col-12 col-md-8 px-0 d-flex align-items-center mt-1">
                <atom-input
                  v-model="currentConfigData.smtpServerConfig.username"
                  title="Username"
                  placeholder="Username"
                  :isAsterisk="true"
                  :isError="isErrorAtSmtpServerConfigUsername"
                  :isDisable="!hasUpdatePermission"
                ></atom-input>
              </div>
              <div class="col-12 col-md-8 px-0 d-flex align-items-center mt-1">
                <atom-input
                  v-model="currentConfigData.smtpServerConfig.password"
                  title="Password"
                  placeholder="Password"
                  type="password"
                  :isAsterisk="true"
                  :isError="isErrorAtSmtpServerConfigPassword"
                  :isDisable="!hasUpdatePermission"
                ></atom-input>
              </div>
            </div>

            <div class="d-flex flex-column setting__item">
              <div class="col-12 px-0 text__header d-flex align-items-center">
                Ticket Management
              </div>
              <div
                class="col-12 px-0 text__sub-header d-flex align-items-center"
              >
                Email Report
              </div>
              <div class="col-12 col-lg-8 px-0 custom-config-box p-1 mt-1">
                <div class="px-0">
                  <atom-switch
                    v-model="currentConfigData.ticketSummaryWorkerConfig.enable"
                    :isDisable="!hasUpdatePermission"
                    title="Enable"
                  ></atom-switch>

                  <div class="d-flex custom-small-font mt-1">
                    <span>Cron Expression (UTC Format)</span>
                    <span class="text-danger">*</span>
                    <div class="d-flex align-items-center custom-margin-left">
                      <div id="ticket-cron-expression" class="d-flex">
                        <feather-icon
                          icon="InfoIcon"
                          size="12"
                          class="alert__icon"
                        />
                      </div>
                      <b-tooltip
                        target="ticket-cron-expression"
                        placement="right"
                        boundary="window"
                        variant="primary"
                      >
                        <div class="description__container">
                          <div>Coordinated Universal Time (UTC)</div>
                          <a href="https://crontab.guru/" target="_blank"
                            >Example: crontab</a
                          >
                        </div>
                      </b-tooltip>
                    </div>
                  </div>
                  <div class="d-flex">
                    <atom-input
                      v-model="currentTicketCronExpression.minute"
                      class="mr-1"
                      :isError="isErrorAtTicketCronExpressionMinute"
                      :isDisable="
                        !currentConfigData.ticketSummaryWorkerConfig.enable ||
                        !hasUpdatePermission
                      "
                    ></atom-input>
                    <atom-input
                      v-model="currentTicketCronExpression.hour"
                      class="mr-1"
                      :isError="isErrorAtTicketCronExpressionHour"
                      :isDisable="
                        !currentConfigData.ticketSummaryWorkerConfig.enable ||
                        !hasUpdatePermission
                      "
                    ></atom-input>
                    <atom-input
                      v-model="currentTicketCronExpression.dayMonth"
                      class="mr-1"
                      :isError="isErrorAtTicketCronExpressionDayMonth"
                      :isDisable="
                        !currentConfigData.ticketSummaryWorkerConfig.enable ||
                        !hasUpdatePermission
                      "
                    ></atom-input>
                    <atom-input
                      v-model="currentTicketCronExpression.month"
                      class="mr-1"
                      :isError="isErrorAtTicketCronExpressionMonth"
                      :isDisable="
                        !currentConfigData.ticketSummaryWorkerConfig.enable ||
                        !hasUpdatePermission
                      "
                    ></atom-input>
                    <atom-input
                      v-model="currentTicketCronExpression.dayWeek"
                      :isError="isErrorAtTicketCronExpressionDayWeek"
                      :isDisable="
                        !currentConfigData.ticketSummaryWorkerConfig.enable ||
                        !hasUpdatePermission
                      "
                    ></atom-input>
                  </div>
                </div>
                <div class="px-0 d-flex align-items-center mt-1">
                  <atom-input
                    v-model="
                      currentConfigData.ticketSummaryWorkerConfig.emailRecipient
                    "
                    title="Email Recipient"
                    placeholder="Email Recipient"
                    :isAsterisk="true"
                    :isError="isErrorAtTicketConfigEmailRecipient"
                    :errorMessage="errorMessageAtInputEmail"
                    :isDisable="
                      !currentConfigData.ticketSummaryWorkerConfig.enable ||
                      !hasUpdatePermission
                    "
                  ></atom-input>
                </div>
              </div>

              <!-- we use fixed incident/job data instead. -->
              <!-- <div
                class="col-12 px-0 text__sub-header d-flex align-items-center mt-2"
              >
                Incident / Job Default Information
              </div>
              <div class="col-12 col-md-8 px-0 d-flex align-items-center mt-1">
                <atom-input
                  v-model="
                    currentConfigData.ticketIncidentDefaultInfo
                      .incidentCustomerName
                  "
                  title="Customer Name"
                  placeholder="Customer Name"
                ></atom-input>
              </div>
              <div class="col-12 col-md-8 px-0 d-flex align-items-center mt-1">
                <atom-input
                  v-model="
                    currentConfigData.ticketIncidentDefaultInfo
                      .incidentCustomerEmail
                  "
                  title="Email"
                  placeholder="Email"
                  :isError="isErrorAtTicketConfigCustomerEmail"
                  :errorMessage="errorMessageAtInputEmail"
                ></atom-input>
              </div>
              <div class="col-12 col-md-8 px-0 d-flex align-items-center mt-1">
                <atom-input
                  v-model="
                    currentConfigData.ticketIncidentDefaultInfo
                      .incidentCustomerPhoneNumber
                  "
                  title="Phone Number"
                  placeholder="Phone Number"
                ></atom-input>
              </div> -->
            </div>

            <!-- <div class="d-flex flex-column setting__item">
              <div class="col-12 px-0 text__header">Inventory</div>
              <div class="col-12 col-lg-5 px-0 mt-1">
                <div class="row">
                  <div class="col-8">
                    <div class="d-flex align-items-center custom-small-font">
                      <span>
                        MA Near Expiry
                        <span class="font-color-danger">*</span>
                      </span>
                      <div class="d-flex custom-margin-left">
                        <div id="inventory-near-expire">
                          <feather-icon
                            icon="InfoIcon"
                            size="12"
                            class="alert__icon"
                          />
                        </div>
                        <b-tooltip
                          target="inventory-near-expire"
                          placement="right"
                          boundary="window"
                          variant="primary"
                        >
                          <div class="description__container">
                            <span>
                              ระยะเวลาที่ระบุว่าอุปกรณ์มี MA ที่ใกล้หมดอายุ
                            </span>
                          </div>
                        </b-tooltip>
                      </div>
                    </div>
                    <atom-input
                      v-model="
                        currentConfigData.wpmInventoryConfig.maNearExpiryMonths
                      "
                      placeholder="6"
                      :isError="isErrorAtMaNearExpiryMonths"
                      errorMessage="Value must be positive integer"
                    ></atom-input>
                  </div>
                  <div class="col-4">
                    <div class="custom-margin-top-30">Month</div>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="d-flex flex-column pt-2">
              <div class="col-12 px-0 text__header d-flex align-items-center">
                Server Management Module
              </div>
              <div class="col-12 col-md-8 px-0 d-flex align-items-center mt-1">
                <atom-input
                  v-model="
                    currentConfigData.serverManagementConfig
                      .workerRunningInterval
                  "
                  title="Resource Monitoring Interval"
                  placeholder="Resource Monitoring Interval"
                  :isAsterisk="true"
                  :isDisable="true"
                  :isError="false"
                ></atom-input>
                <span class="setting__unit">Second</span>
              </div>
            </div>
            <div class="d-flex mt-1 custom-small-font">Alert</div>
            <div class="d-block d-xl-flex custom-line">
              <div class="col-12 col-xl-3 my-1 my-xl-0 custom-config-box">
                <div class="custom-font--header mb-1">
                  <span
                    :class="{
                      'text-primary':
                        currentConfigData.serverManagementConfig.email.enable,
                    }"
                    >EMAIL</span
                  >
                </div>
                <atom-switch
                  v-model="
                    currentConfigData.serverManagementConfig.email.enable
                  "
                  :isDisable="!hasUpdatePermission"
                  title="Enable email alert"
                ></atom-switch>
              </div>
              <div
                class="col-12 col-xl-4 my-1 my-xl-0 mx-xl-1 custom-config-box"
              >
                <div class="custom-font--header mb-1">
                  <span
                    :class="{
                      'text-primary':
                        currentConfigData.serverManagementConfig.sms.enable,
                    }"
                    >SMS</span
                  >
                </div>
                <atom-switch
                  v-model="currentConfigData.serverManagementConfig.sms.enable"
                  :isDisable="!hasUpdatePermission"
                  title="Enable SMS alert"
                ></atom-switch>
                <atom-input
                  v-model="
                    currentConfigData.serverManagementConfig.sms.smsGatewayPath
                  "
                  title="SMS Gateway Path"
                  placeholder="SMS Gateway Path"
                  class="mt-1"
                  :isAsterisk="true"
                  :isError="isErrorAtServerManagementConfigSmsGatewayPath"
                  :isDisable="
                    !currentConfigData.serverManagementConfig.sms.enable ||
                    !hasUpdatePermission
                  "
                ></atom-input>
              </div>
              <div class="col-12 col-xl-4 my-1 my-xl-0 custom-config-box">
                <div class="custom-font--header mb-1">
                  <span
                    :class="{
                      'text-primary':
                        currentConfigData.serverManagementConfig.line.enable,
                    }"
                    >LINE</span
                  >
                </div>
                <atom-switch
                  v-model="currentConfigData.serverManagementConfig.line.enable"
                  :isDisable="!hasUpdatePermission"
                  title="Enable Line alert"
                ></atom-switch>
                <atom-input
                  v-model="
                    currentConfigData.serverManagementConfig.line.lineApiPath
                  "
                  title="Line Api Path"
                  placeholder="Line Api Path"
                  class="mt-1"
                  :isAsterisk="true"
                  :isError="isErrorAtServerManagementConfigLineApiPath"
                  :isDisable="
                    !currentConfigData.serverManagementConfig.line.enable ||
                    !hasUpdatePermission
                  "
                ></atom-input>
              </div>
            </div>

            <!-- ! IN CASE THAT NEED ADMIN PASSWORD RECOVERY -->
            <!-- <div class="row setting__item">
              <div class="col-12 px-0 text__header d-flex align-items-center">
                Admin Configuration
              </div>
              <div class="col-12 col-md-7 px-0 d-flex align-items-center w-75">
                <atom-input
                  title="Recovery Email"
                  :isAsterisk="true"
                  placeholder="Recovery Email"
                  v-model="adminConfig.recoveryEmail"
                ></atom-input>
              </div>
            </div> -->
            <!-- ! IN CASE THAT NEED ADMIN PASSWORD RECOVERY -->

            <div class="d-flex flex-column setting__item">
              <div class="col-12 px-0 text__header d-flex align-items-center">
                Network Configuration
              </div>
              <div
                class="col-12 px-0 text__sub-header d-flex align-items-center"
              >
                Configuration Backup Interval
              </div>
              <div class="col-12 col-lg-8 px-0 custom-config-box p-1 mt-1">
                <div>
                  <atom-switch
                    v-model="
                      currentConfigData
                        .networkConfigurationManagementWorkerConfig.enable
                    "
                    :isDisable="!hasUpdatePermission"
                    title="Enable"
                  ></atom-switch>
                </div>
                <div class="d-flex custom-small-font mt-1">
                  <span>Cron Expression (UTC Format)</span>
                  <span class="text-danger">*</span>
                  <div class="d-flex align-items-center custom-margin-left">
                    <div id="network-config-cron-expression" class="d-flex">
                      <feather-icon
                        icon="InfoIcon"
                        size="12"
                        class="alert__icon"
                      />
                    </div>
                    <b-tooltip
                      target="network-config-cron-expression"
                      placement="right"
                      boundary="window"
                      variant="primary"
                    >
                      <div class="description__container">
                        <div>Coordinated Universal Time (UTC)</div>
                        <a href="https://crontab.guru/" target="_blank"
                          >Example: crontab</a
                        >
                      </div>
                    </b-tooltip>
                  </div>
                </div>
                <div class="d-flex">
                  <atom-input
                    v-model="currentNetworkConfigCronExpression.minute"
                    class="mr-1"
                    :isError="isErrorAtNetworkConfigCronExpressionMinute"
                    :isDisable="
                      !currentConfigData
                        .networkConfigurationManagementWorkerConfig.enable ||
                      !hasUpdatePermission
                    "
                  ></atom-input>
                  <atom-input
                    v-model="currentNetworkConfigCronExpression.hour"
                    class="mr-1"
                    :isError="isErrorAtNetworkConfigCronExpressionHour"
                    :isDisable="
                      !currentConfigData
                        .networkConfigurationManagementWorkerConfig.enable ||
                      !hasUpdatePermission
                    "
                  ></atom-input>
                  <atom-input
                    v-model="currentNetworkConfigCronExpression.dayMonth"
                    class="mr-1"
                    :isError="isErrorAtNetworkConfigCronExpressionDayMonth"
                    :isDisable="
                      !currentConfigData
                        .networkConfigurationManagementWorkerConfig.enable ||
                      !hasUpdatePermission
                    "
                  ></atom-input>
                  <atom-input
                    v-model="currentNetworkConfigCronExpression.month"
                    class="mr-1"
                    :isError="isErrorAtNetworkConfigCronExpressionMonth"
                    :isDisable="
                      !currentConfigData
                        .networkConfigurationManagementWorkerConfig.enable ||
                      !hasUpdatePermission
                    "
                  ></atom-input>
                  <atom-input
                    v-model="currentNetworkConfigCronExpression.dayWeek"
                    :isError="isErrorAtNetworkConfigCronExpressionDayWeek"
                    :isDisable="
                      !currentConfigData
                        .networkConfigurationManagementWorkerConfig.enable ||
                      !hasUpdatePermission
                    "
                  ></atom-input>
                </div>
              </div>

              <div class="mt-3 d-flex">
                <atom-button
                  buttonId="btn-force-fetch"
                  buttonStyle="border"
                  @click="forceFetch"
                  >Force Fetch Configuration</atom-button
                >
              </div>
            </div>

            <div class="row setting__item">
              <div class="col-12 px-0 ml-1 text__header">License</div>
              <div class="col-12 px-0 d-flex align-items-center mt-1">
                <ul>
                  <li>License for one physical server web portal</li>
                  <li>Unlimited ticket license</li>
                  <li>Unlimited access management license</li>
                  <li>Unlimited {{ contractLabel }} contract license</li>
                  <!-- <li>Unlimited smart hand order license</li>
                  <li>Unlimited cross connect license</li>
                  <li>Unlimited parcel list license</li>
                  <li>Unlimited number of inventory license</li> -->
                </ul>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end my-2">
            <!-- ! IN CASE THAT NEED RESET PASSWORD BUTTON -->
            <!-- <atom-button
              buttonId="button-save"
              buttonStyle="border"
              @click="resetSetting"
              >Reset</atom-button
            > -->
            <!-- ! IN CASE THAT NEED RESET PASSWORD BUTTON -->

            <atom-button
              v-if="hasUpdatePermission"
              buttonId="button-save"
              :isDisable="!isConfigDataChange || !hasUpdatePermission"
              @click="clickSaveChangeSetting"
              >Save change</atom-button
            >
          </div>
        </div>
      </div>
    </b-card>
    <footer style="height: 28px"></footer>

    <molecule-modal-dialog
      modalId="modal-confirm-save-change-global-setting"
      icon="AlertCircleIcon"
      textTitle="Do you want to change setting for website?"
      textSubtitle="This action will affect to all user"
      buttonTextLeft="Confirm"
      :isTextCenter="true"
      :isSlotBody="true"
      :isDisableButtonLeft="isDisabledButtonConfirmSaveChange"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="updateGlobalSetting"
      @clickButtonRight="textConfirmSaveChangeGlobalSetting = ''"
      @clickIconClose="textConfirmSaveChangeGlobalSetting = ''"
    >
      <template #body>
        <div class="col-12 col-md-8">
          <atom-input
            placeholder="confirm save change"
            title="Please type “confirm save change” to confirm"
            v-model="textConfirmSaveChangeGlobalSetting"
          ></atom-input>
        </div>
      </template>
    </molecule-modal-dialog>

    <molecule-modal-dialog
      modalId="modal-force-fetch"
      :textTitle="`Do you want to fetch\nconfiguration data?`"
      icon="AlertCircleIcon"
      :isCloseOnBackDrop="false"
      :isSlotBody="true"
      buttonTextLeft="Confirm"
      @clickButtonLeft="confirmForceFetch"
    >
      <template #body>
        <div class="text-center my-1">
          Other settings that have not been applied will be canceled.<br />
          This page will take about 2 minutes to fetch the data and will not be
          able<br />
          to do any action during that time.
        </div>
      </template>
    </molecule-modal-dialog>

    <molecule-modal-dialog
      modalId="modal-force-fetching-loading"
      :isCloseOnBackDrop="false"
      :isButtonLeft="false"
      :isButtonRight="false"
      :isShowXIcon="false"
      :isSlotBody="true"
    >
      <template #body>
        <div class="d-flex flex-column align-items-center">
          <div class="loading-container">
            <div class="loading">
              <div class="effect-1 effects"></div>
              <div class="effect-2 effects"></div>
              <div class="effect-3 effects"></div>
            </div>
          </div>

          <div class="text-center">
            <label class="text-title">Fetching Data</label><br />
            This page will take about 2 minutes to fetch the data and will not
            be able<br />
            to do any action during that time.
          </div>
        </div>
      </template>
    </molecule-modal-dialog>
  </div>
</template>

<script>
import { DateTime } from "luxon"
import { BCard, BTooltip, BBadge } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import {
  getSettings,
  getMonitoring,
  updateSettings,
  updateTicketIncidentDefaultInfo,
} from "@/api/api-module-config"
import mixins from "@/mixins"
import mixinsValidator from "@/mixins/mixinsValidator"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
import mixinsUser from "@/mixins/mixinsUser"
import { PermissionUser } from "@/constants/permission-user"

export default {
  name: "OrganismGlobalSetting",
  components: {
    AtomButton,
    AtomInput,
    AtomSwitch,
    BCard,
    BTooltip,
    BBadge,
    MoleculeModalDialog,
  },
  mixins: [mixins, mixinsValidator, mixinsObjectHelper, mixinsUser],
  data() {
    return {
      currentStatus: {
        webService: {
          status: "SUCCESS",
          date: "",
          isLoading: true,
        },
        apiServices: {
          status: "SUCCESS",
          date: "",
          isLoading: true,
        },
        databaseBackup: {
          status: "SUCCESS",
          date: "",
          isLoading: true,
        },
      },
      errorMessageAtInputEmail: "Please enter valid email", // Added
      isValidateTrigger: false,
      isValidateDepartmentTrigger: false,
      modalId: null,
      allGlobalConfigKey: {
        iamConfig: {
          jwtTokenLifetimeHours: 24,
        },
        smtpServerConfig: {
          host: "",
          port: 0,
          password: "",
          username: "",
          sourceEmail: "",
        },
        notificationConfig: {
          refreshInterval: 30,
          expirationInterval: 7,
        },
        serverManagementConfig: {
          sms: {
            enable: false,
            smsGatewayPath: "",
          },
          line: {
            enable: false,
            lineApiPath: "https://notify-api.line.me/api/notify",
          },
          email: {
            enable: false,
          },
          workerRunningInterval: 300,
        },
        ticketIncidentDefaultInfo: {
          incidentCustomerName: "",
          incidentCustomerEmail: "",
          incidentCustomerPhoneNumber: "",
        },
        ticketSummaryWorkerConfig: {
          enable: false,
          cronExpression: "",
          emailRecipient: "",
        },
        networkConfigurationManagementWorkerConfig: {
          enable: false,
          cronExpression: "",
          firstTimeFetchingEnable: false,
          firstTimeFetchingCronExpression: "",
          forceFetching: false,
        },
        wpmInventoryConfig: {
          maNearExpiryMonths: 6,
        },
      },
      currentConfigData: {},
      originConfigData: {},
      currentTicketCronExpression: {
        minute: "",
        hour: "",
        dayMonth: "",
        month: "",
        dayWeek: "",
      },
      currentNetworkConfigCronExpression: {
        minute: "",
        hour: "",
        dayMonth: "",
        month: "",
        dayWeek: "",
      },
      isGlobalSettingsLoading: true,
      isFirstTimeLoading: true,
      textConfirmSaveChangeGlobalSetting: "",
    }
  },
  computed: {
    hasUpdatePermission() {
      return this.hasPermission(PermissionUser.SETTINGS_WRITE)
    },
    isConfigDataChange() {
      return this.compareIsChangeObject(
        this.currentConfigData,
        this.originConfigData
      )
    },
    isErrorAtTokenLifetime() {
      return this.isValidateTrigger
        ? !this.isPositiveInteger(
            this.currentConfigData?.iamConfig?.jwtTokenLifetimeHours
          )
        : false
    },
    isErrorAtDepartmentManagementEmail() {
      return this.isValidateDepartmentTrigger
        ? this.departmentManagement.some((department) => {
            return (
              this.isInvalidEmail(department.departmentEmail) &&
              this.hasString(department.departmentEmail)
            )
          })
        : false
    },
    isErrorAtSmtpServerConfigHost() {
      return this.isValidateTrigger
        ? this.isEmptyString(this.currentConfigData?.smtpServerConfig?.host)
        : false
    },
    isErrorAtSmtpServerConfigPort() {
      return this.isValidateTrigger
        ? this.isNotNumeric(this.currentConfigData?.smtpServerConfig?.port)
        : false
    },
    isErrorAtSmtpServerConfigPassword() {
      return this.isValidateTrigger
        ? this.isEmptyString(this.currentConfigData?.smtpServerConfig?.password)
        : false
    },
    isErrorAtSmtpServerConfigUsername() {
      return this.isValidateTrigger
        ? this.isEmptyString(this.currentConfigData?.smtpServerConfig?.username)
        : false
    },
    // isErrorAtSmtpServerConfigSourceEmail() {
    //   return this.isValidateTrigger
    //     ? this.isEmptyString(
    //         this.currentConfigData.smtpServerConfig.sourceEmail
    //       )
    //     : false
    // },
    isErrorAtServerManagementConfigSmsGatewayPath() {
      return this.isValidateTrigger
        ? this.currentConfigData?.serverManagementConfig?.sms?.enable &&
            this.isEmptyString(
              this.currentConfigData.serverManagementConfig.sms?.smsGatewayPath
            )
        : false
    },
    isErrorAtServerManagementConfigLineApiPath() {
      return this.isValidateTrigger
        ? this.currentConfigData?.serverManagementConfig?.line?.enable &&
            this.isEmptyString(
              this.currentConfigData.serverManagementConfig.line?.lineApiPath
            )
        : false
    },
    // isErrorAtServerManagementConfigWorkerRunningInterval() {
    //   return this.isValidateTrigger
    //     ? this.isNotNumeric(
    //         this.currentConfigData.serverManagementConfig.workerRunningInterval
    //       )
    //     : false
    // },
    isErrorAtTicketConfigCustomerEmail() {
      return this.isValidateTrigger
        ? this.isEmptyString(
            this.currentConfigData?.ticketIncidentDefaultInfo
              ?.incidentCustomerEmail
          ) ||
            this.isInvalidEmail(
              this.currentConfigData?.ticketIncidentDefaultInfo
                ?.incidentCustomerEmail
            )
        : false
    },
    isErrorAtTicketConfigEmailRecipient() {
      return this.isValidateTrigger
        ? this.currentConfigData?.ticketSummaryWorkerConfig?.enable &&
            (this.isEmptyString(
              this.currentConfigData?.ticketSummaryWorkerConfig?.emailRecipient
            ) ||
              this.isInvalidEmail(
                this.currentConfigData?.ticketSummaryWorkerConfig
                  ?.emailRecipient
              ))
        : false
    },
    isErrorAtTicketCronExpressionMinute() {
      return this.isValidateTrigger
        ? this.currentConfigData?.ticketSummaryWorkerConfig?.enable &&
            this.isEmptyString(this.currentTicketCronExpression?.minute)
        : false
    },
    isErrorAtTicketCronExpressionHour() {
      return this.isValidateTrigger
        ? this.currentConfigData?.ticketSummaryWorkerConfig?.enable &&
            this.isEmptyString(this.currentTicketCronExpression?.hour)
        : false
    },
    isErrorAtTicketCronExpressionDayMonth() {
      return this.isValidateTrigger
        ? this.currentConfigData?.ticketSummaryWorkerConfig?.enable &&
            this.isEmptyString(this.currentTicketCronExpression?.dayMonth)
        : false
    },
    isErrorAtTicketCronExpressionMonth() {
      return this.isValidateTrigger
        ? this.currentConfigData?.ticketSummaryWorkerConfig?.enable &&
            this.isEmptyString(this.currentTicketCronExpression?.month)
        : false
    },
    isErrorAtTicketCronExpressionDayWeek() {
      return this.isValidateTrigger
        ? this.currentConfigData?.ticketSummaryWorkerConfig?.enable &&
            this.isEmptyString(this.currentTicketCronExpression?.dayWeek)
        : false
    },
    // isErrorAtTicketConfigIncidentCustomerName() {
    //   return this.isValidateTrigger
    //     ? this.isEmptyString(
    //         this.currentConfigData.ticketIncidentDefaultInfo
    //           .incidentCustomerName
    //       )
    //     : false
    // },
    // isErrorAtTicketConfigIncidentCustomerEmail() {
    //   return this.isValidateTrigger
    //     ? this.isEmptyString(
    //         this.currentConfigData.ticketIncidentDefaultInfo
    //           .incidentCustomerEmail
    //       )
    //     : false
    // },
    // isErrorAtTicketConfigIncidentCustomerPhoneNumber() {
    //   return this.isValidateTrigger
    //     ? this.isEmptyString(
    //         this.currentConfigData.ticketIncidentDefaultInfo
    //           .incidentCustomerPhoneNumber
    //       )
    //     : false
    // },
    isErrorAtNetworkConfigCronExpressionMinute() {
      return this.isValidateTrigger
        ? this.currentConfigData?.networkConfigurationManagementWorkerConfig
            ?.enable &&
            this.isEmptyString(this.currentNetworkConfigCronExpression?.minute)
        : false
    },
    isErrorAtNetworkConfigCronExpressionHour() {
      return this.isValidateTrigger
        ? this.currentConfigData?.networkConfigurationManagementWorkerConfig
            ?.enable &&
            this.isEmptyString(this.currentNetworkConfigCronExpression?.hour)
        : false
    },
    isErrorAtNetworkConfigCronExpressionDayMonth() {
      return this.isValidateTrigger
        ? this.currentConfigData.networkConfigurationManagementWorkerConfig
            ?.enable &&
            this.isEmptyString(
              this.currentNetworkConfigCronExpression?.dayMonth
            )
        : false
    },
    isErrorAtNetworkConfigCronExpressionMonth() {
      return this.isValidateTrigger
        ? this.currentConfigData.networkConfigurationManagementWorkerConfig
            ?.enable &&
            this.isEmptyString(this.currentNetworkConfigCronExpression?.month)
        : false
    },
    isErrorAtNetworkConfigCronExpressionDayWeek() {
      return this.isValidateTrigger
        ? this.currentConfigData.networkConfigurationManagementWorkerConfig
            ?.enable &&
            this.isEmptyString(this.currentNetworkConfigCronExpression?.dayWeek)
        : false
    },
    isErrorAtRefreshInterval() {
      return this.isValidateTrigger
        ? !this.isPositiveInteger(
            this.currentConfigData?.notificationConfig?.refreshInterval
          )
        : false
    },
    isErrorAtExpirationInterval() {
      return this.isValidateTrigger
        ? !this.isPositiveInteger(
            this.currentConfigData?.notificationConfig?.expirationInterval
          )
        : false
    },
    isErrorAtMaNearExpiryMonths() {
      return this.isValidateTrigger
        ? !this.isPositiveInteger(
            this.currentConfigData?.wpmInventoryConfig?.maNearExpiryMonths
          )
        : false
    },
    isErrorOccur() {
      return (
        this.isErrorAtTokenLifetime ||
        this.isErrorAtSmtpServerConfigHost ||
        this.isErrorAtSmtpServerConfigPort ||
        this.isErrorAtSmtpServerConfigPassword ||
        this.isErrorAtSmtpServerConfigUsername ||
        this.isErrorAtServerManagementConfigSmsGatewayPath ||
        this.isErrorAtServerManagementConfigLineApiPath ||
        this.isErrorAtTicketConfigCustomerEmail ||
        this.isErrorAtTicketConfigEmailRecipient ||
        this.isErrorAtTicketCronExpressionMinute ||
        this.isErrorAtTicketCronExpressionHour ||
        this.isErrorAtTicketCronExpressionDayMonth ||
        this.isErrorAtTicketCronExpressionMonth ||
        this.isErrorAtTicketCronExpressionDayWeek ||
        this.isErrorAtNetworkConfigCronExpressionMinute ||
        this.isErrorAtNetworkConfigCronExpressionHour ||
        this.isErrorAtNetworkConfigCronExpressionDayMonth ||
        this.isErrorAtNetworkConfigCronExpressionMonth ||
        this.isErrorAtNetworkConfigCronExpressionDayWeek ||
        this.isErrorAtRefreshInterval ||
        this.isErrorAtExpirationInterval ||
        this.isErrorAtMaNearExpiryMonths
      )
    },
    isDisabledButtonConfirmSaveChange() {
      return (
        this.textConfirmSaveChangeGlobalSetting.toLowerCase() !==
        "confirm save change"
      )
    },
  },
  watch: {
    currentTicketCronExpression: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          const { minute, hour, dayMonth, month, dayWeek } =
            this.currentTicketCronExpression
          const formattedMinute = minute.replace(/\s/g, "")
          const formattedHour = hour.replace(/\s/g, "")
          const formattedDayMonth = dayMonth.replace(/\s/g, "")
          const formattedMonth = month.replace(/\s/g, "")
          const formattedDayWeek = dayWeek.replace(/\s/g, "")
          const cronExpression = `${formattedMinute} ${formattedHour} ${formattedDayMonth} ${formattedMonth} ${formattedDayWeek}`

          this.currentConfigData.ticketSummaryWorkerConfig.cronExpression =
            cronExpression
        }
      },
    },
    currentNetworkConfigCronExpression: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          const { minute, hour, dayMonth, month, dayWeek } =
            this.currentNetworkConfigCronExpression
          const formattedMinute = minute.replace(/\s/g, "")
          const formattedHour = hour.replace(/\s/g, "")
          const formattedDayMonth = dayMonth.replace(/\s/g, "")
          const formattedMonth = month.replace(/\s/g, "")
          const formattedDayWeek = dayWeek.replace(/\s/g, "")
          const cronExpression = `${formattedMinute} ${formattedHour} ${formattedDayMonth} ${formattedMonth} ${formattedDayWeek}`

          this.currentConfigData.networkConfigurationManagementWorkerConfig.cronExpression =
            cronExpression
        }
      },
    },
  },
  async mounted() {
    await this.getSettingsInfo("allSettings")
    this.getCurrentStatusFromApi()
  },
  methods: {
    statusWording(status) {
      if (status === "SUCCESS") return "Normal"
      return "Failed"
    },
    statusVariant(status) {
      if (status === "SUCCESS") return "light-success"
      return "light-danger"
    },

    async getCurrentStatusFromApi() {
      this.currentStatus.webService = {
        status: "SUCCESS",
        date: `${DateTime.now().toFormat("dd/MM/yyyy HH")}:00`,
        isLoading: false,
      }
      this.currentStatus.apiServices = {
        status: "SUCCESS",
        date: `${DateTime.now().toFormat("dd/MM/yyyy HH")}:00`,
        isLoading: false,
      }
      await getMonitoring().then((response) => {
        this.currentStatus.databaseBackup = {
          status: response.value.databaseBackupStatus,
          date: DateTime.fromISO(
            response.value.databaseBackupUpdatedAt
          ).toFormat("dd/MM/yyyy HH:mm"),
          isLoading: false,
        }
      })
    },

    async getSettingsInfo(key) {
      this.showLoading(true)
      this.isGlobalSettingsLoading = true
      await getSettings(key)
        .then((response) => {
          const configData = response.value
          this.normalizeConfigData(configData)
          this.currentConfigData = this.checkAndSetMissingKeys(
            this.allGlobalConfigKey,
            configData
          )
          this.originConfigData = this.deepCopyObject(this.currentConfigData)
          this.splitCronExpression(
            "Ticket",
            configData.ticketSummaryWorkerConfig.cronExpression
          )
          this.splitCronExpression(
            "Network",
            configData.networkConfigurationManagementWorkerConfig.cronExpression
          )
          if (
            this.currentConfigData.networkConfigurationManagementWorkerConfig
              .forceFetching === true
          ) {
            this.openModal("modal-force-fetching-loading")
            setTimeout(this.closeModalAndReload, 30000)
          }
        })
        .finally(() => {
          this.showLoading(false)
          this.isGlobalSettingsLoading = false
          this.isFirstTimeLoading = false
        })
    },

    normalizeConfigData(configData) {
      const fieldsToConvert = [
        "iamConfig.jwtTokenLifetimeHours",
        "wpmInventoryConfig.maNearExpiryMonths",
        "smtpServerConfig.port",
        "serverManagementConfig.workerRunningInterval",
        "notificationConfig.refreshInterval",
        "notificationConfig.expirationInterval",
      ]

      for (const field of fieldsToConvert) {
        const nestedKeys = field.split(".")
        let currentObj = configData

        for (const nestedKey of nestedKeys) {
          if (currentObj && currentObj.hasOwnProperty(nestedKey)) {
            if (nestedKey === nestedKeys[nestedKeys.length - 1]) {
              // Convert the last nested key to a number
              currentObj[nestedKey] = Number(currentObj[nestedKey])
            }
            currentObj = currentObj[nestedKey]
          } else {
            // Break out if any parent key is undefined or null
            break
          }
        }
      }
    },

    checkAndSetMissingKeys(allGlobalConfig, currentData) {
      const result = {}

      for (const key in allGlobalConfig) {
        if (
          typeof allGlobalConfig[key] === "object" &&
          allGlobalConfig[key] !== null
        ) {
          // If the key in allGlobalConfig is an object, recursively check and set missing keys
          result[key] = this.checkAndSetMissingKeys(
            allGlobalConfig[key],
            currentData[key] || {}
          )
        } else {
          // Check if the key is missing in currentData
          if (!(key in currentData)) {
            // If missing, set the key and value from allGlobalConfig
            result[key] = allGlobalConfig[key]
          } else {
            // If not missing, use the value from currentData
            result[key] = currentData[key]
          }
        }
      }
      return result
    },

    splitCronExpression(module, cronExpression) {
      if (module === "Ticket") {
        this.currentTicketCronExpression.minute = cronExpression.split(" ")[0]
        this.currentTicketCronExpression.hour = cronExpression.split(" ")[1]
        this.currentTicketCronExpression.dayMonth = cronExpression.split(" ")[2]
        this.currentTicketCronExpression.month = cronExpression.split(" ")[3]
        this.currentTicketCronExpression.dayWeek = cronExpression.split(" ")[4]
      }
      if (module === "Network") {
        this.currentNetworkConfigCronExpression.minute =
          cronExpression.split(" ")[0]
        this.currentNetworkConfigCronExpression.hour =
          cronExpression.split(" ")[1]
        this.currentNetworkConfigCronExpression.dayMonth =
          cronExpression.split(" ")[2]
        this.currentNetworkConfigCronExpression.month =
          cronExpression.split(" ")[3]
        this.currentNetworkConfigCronExpression.dayWeek =
          cronExpression.split(" ")[4]
      }
    },

    clickSaveChangeSetting() {
      this.isValidateTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccur) {
          this.openModal("modal-confirm-save-change-global-setting")
        } else {
          this.toastWarning("Please Check Your Data")
        }
      })
    },

    async updateGlobalSetting(isShowToast = true, isNewLoad = true) {
      this.closeModal()
      this.textConfirmSaveChangeGlobalSetting = ""
      this.normalizeConfigData(this.currentConfigData)

      try {
        const updatePlayLoadData = this.deepCopyObject(this.currentConfigData)
        this.removeSortedKeys(updatePlayLoadData)

        await this.updateSettingsAsync(updatePlayLoadData)

        // we use fixed incident data instead
        // await this.updateTicketIncidentDefaultInfoAsync()

        if (isShowToast) this.toastSuccess("Save setting successfully")
        if (isNewLoad) this.getSettingsInfo("allSettings")
        this.isValidateTrigger = false
      } catch {
        this.toastError("Save setting failed")
        this.isValidateTrigger = false
      }
    },

    async updateSettingsAsync(updatePlayLoadData) {
      const response = await updateSettings(updatePlayLoadData)

      if (!response) {
        throw new Error("Update settings failed")
      }
    },

    // we use fixed incident data instead
    // async updateTicketIncidentDefaultInfoAsync() {
    //   await updateTicketIncidentDefaultInfo(
    //     this.currentConfigData.ticketIncidentDefaultInfo
    //   )
    // },

    removeSortedKeys(obj) {
      for (const key in obj) {
        if (key === "_sortedKeys") {
          delete obj[key]
        } else if (typeof obj[key] === "object" && obj[key] !== null) {
          // Recursively remove "_sortedKeys" property from nested objects
          this.removeSortedKeys(obj[key])
        }
      }
    },

    // async resetSetting() {
    //   await this.getSettingsInfo("defaultAllSettings")
    //   await this.updateSettings()
    // },

    // modal
    openModal(id) {
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },

    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },

    forceFetch() {
      this.openModal("modal-force-fetch")
    },

    async confirmForceFetch() {
      this.closeModal()

      this.currentConfigData.networkConfigurationManagementWorkerConfig.forceFetching = true
      await this.updateGlobalSetting(false, false)

      this.openModal("modal-force-fetching-loading")
      setTimeout(this.closeModalAndReload, 120000)
    },

    closeModalAndReload() {
      this.closeModal()
      this.getSettingsInfo("allSettings")
    },
  },
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 0;
}

.card-padding {
  padding: 1.5rem;
}

.setting-value {
  min-height: calc(100vh - 260px);
}

.setting__item {
  border-bottom: 1px solid #ebe9f1;
  padding: 30px 0;
}

.text__header {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
}

.text__department {
  color: #5e5873;
  font-weight: 500;
  font-size: 16px;
}

.setting__unit {
  margin-top: 23px;
  padding-left: 15px;
}

.setting__scroll {
  overflow: auto;
  width: 100%;
  max-height: calc(100vh - 260px);
}

.custom-config-box {
  padding: 1rem;
  border: 1px solid #b9b9c3;
  border-radius: 6px;
}

.custom-line {
  border-bottom: 1px solid #ebe9f1;
  padding-bottom: 30px;
}

.custom-small-font {
  color: #5e5873;
  font-size: 12px;
  line-height: 1.5;
  margin-bottom: 5px;
}

.custom-font--header {
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  color: #b9b9c3;
}
.custom-margin-left {
  margin-left: 6px;
}
.w-123-px {
  width: 123px;
}

.text-title {
  margin-bottom: 20px;
  font-size: 21px;
  font-weight: 500;
  color: #5e5873;
  white-space: pre-line;
}

.loading-container {
  position: relative;
  width: 55px;
  height: 55px;
  margin: 16px 0 18px;
}

.loading {
  top: 0;
  left: 0;
}

.status__container {
  margin-top: 30px;
}

.text__status {
  color: #b9b9c3;
  font-weight: 500;
  font-size: 16px;
}

.box__status {
  border: 1px solid #b9b9c3;
  border-radius: 6px;
}

.box__status-padding {
  padding: 20px;
}

.text__box-title {
  color: #5e5873;
  font-weight: 600;
  font-size: 14px;
}

.text__box-date {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 12px;
}

.mt-21-px {
  margin-top: 21px;
}

.mb-15-px {
  margin-bottom: 15px;
}

.empty-box-height {
  height: 600px;
}

.empty-card-height {
  height: 86px;
}

.progress2 {
  border-radius: 30px;
  background-color: #eeedfd;
}

.progress-bar2 {
  height: 3px;
  border-radius: 30px;
  transition: 0.4s linear;
  transition-property: width, background-color;
}

.progress-moved .progress-bar2 {
  animation: progress 2s infinite;
}

@keyframes progress {
  0% {
    width: 0%;
    background: #7367f0;
  }

  100% {
    width: 100%;
    background: #7367f0;
  }
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .setting-link {
    border-right: 1px solid #ebe9f1;
    min-height: calc(100vh - 190px);
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
